import { get } from './client'

/**
 * Apparence de la plateforme — lecture PUBLIQUE (`GET /apparence`), sans
 * session : l'écran de connexion porte déjà les couleurs. L'écriture est un
 * appel du périmètre plateforme : `updateApparence` dans `superuser.ts`.
 *
 * `colors`, `radii`, `fonts`, `buttons`, `density`, `shadows`, `header` et `sections` sont typés `unknown` À DESSEIN : ces valeurs finissent
 * dans une feuille de style, et seul `normaliserReglages`
 * (`apparence/reglages.ts`) a le droit de dire qu'elles sont conformes.
 */
export interface ApparenceBrute {
  colors: unknown
  radii: unknown
  fonts: unknown
  buttons: unknown
  density: unknown
  shadows: unknown
  header: unknown
  sections: unknown
  updatedAt: string
}

export function getApparence(): Promise<ApparenceBrute> {
  return get<ApparenceBrute>('/apparence')
}
